import { LocationEnum } from "../locationEnum";

export const locationStrings = {
  [LocationEnum.FrankfurtAmMain]: {
    slug: "frankfurt-am-main",
    fullName: "Frankfurt am Main",
    country: "Deutschland",
    adress: "Westendstraße 50, 60325 Frankfurt am Main",
    street: "Westendstraße",
    houseNumber: "50",
    postalCode: "60325",
    city: "Frankfurt am Main",
    email: "frankfurt@solving.legal",
    phone: {
      moritz: "+4969870022651",
      hubi: "+4969870022650",
    },
  },
  [LocationEnum.Koblenz]: {
    slug: "koblenz",
    fullName: "Koblenz",
    country: "Deutschland",
    adress: "Emser Straße 119, 56076 Koblenz",
    street: "Emser Straße",
    houseNumber: "119",
    postalCode: "56076",
    city: "Koblenz",
    email: "koblenz@solving.legal",
    phone: {
      moritz: "+4969870022651",
      hubi: "+4969870022650",
    },
  },
  [LocationEnum.Landau]: {
    slug: "landau",
    fullName: "Landau",
    country: "Deutschland",
    adress: "Waffenstraße 15, 76829 Landau in der Pfalz",
    street: "Waffenstraße",
    houseNumber: "15",
    postalCode: "76829",
    city: "Landau",
    email: "landau@solving.legal",
    phone: {
      moritz: "+4963416817171",
      hubi: "+4963416817170",
    },
  },
};
